<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        
        <el-form-item label="选择用户" >
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择用户</el-button>
            <ul class="d-s-s select-user"  v-if="formInline.user.user_id > 0">
              <li class="mr10 d-c-c d-c p-10-0" >
                  <img :src="formInline.user.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{formInline.user.nickName}}</p>
              </li>
              <li class="mr10 d-c-c d-c p-10-0" @click="deleteUser">
                  删除
              </li>
            </ul>
          </div>
        </el-form-item>


             <!--选择用户-->
    <GetUser :is_open="open_getuser"  @close="closeGetuserFunc" :multi="multi"></GetUser>
        
        <el-form-item label="动态名称">
          <el-input placeholder="请输入动态名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>

        <el-form-item label="发布时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button  size="small" v-if="showBack" type="info" @click="gotoBack">返回上一页</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" 
      v-auth="'/plus/notes/index/add'"
      @click="addClick">添加动态</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="动态名称" width="100px"></el-table-column>
            <el-table-column label="动态" width="150px">
            <template slot-scope="scope">
              <div class="product-info">
                
                <div class="info">
                  <div class="namex" v-html="scope.row.context"></div>

                </div>
              </div>
            </template>
          </el-table-column>
            
 
            <!-- <el-table-column prop="type_text" label="动态类型"></el-table-column> -->
            <!-- <el-table-column prop="views" label="阅读量"></el-table-column>
            <el-table-column prop="fview" label="虚拟阅读量"></el-table-column>
            <el-table-column prop="likes" label="点赞数"></el-table-column>
            <el-table-column prop="flikes" label="虚拟点赞数"></el-table-column>
            <el-table-column prop="shares" label="分享数"></el-table-column>
            <el-table-column prop="fshares" label="虚拟分享数"></el-table-column>
            <el-table-column prop="is_featured" label="是否推荐"></el-table-column>
            <el-table-column prop="is_pinned" label="是否置顶"></el-table-column> -->
            <el-table-column prop="review_status" label="动态审核状态">
              <template slot-scope="scope">
                <div v-if="scope.row.review_status == 0">未审核</div>
                <div v-if="scope.row.review_status == 1">已通过</div>
                <div v-if="scope.row.review_status == 2">未通过</div>
              </template>

            </el-table-column>
            <el-table-column prop="status" label="上架/下架状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">已下架</div>
                <div v-if="scope.row.status == 1">上架中</div>
              </template>

            </el-table-column>
            <el-table-column prop="create_time" label="发布时间"></el-table-column>
            <el-table-column prop="update_time" label="最后更新时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="evlClick(scope.row)" type="text" size="small">评论</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :notes_id="notes_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_add="open_detail" :notes_id="notes_id"  v-if="open_detail"   @close="closeDetail"></Detail>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import NotesApi from '@/api/notes.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';
  
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      Add,
      Edit,
      GetUser,
      Detail,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          create_time:"",
          user:{
            
          },
          mobile:""
        },

        open_add:false,
        open_edit:false,
        notes_id:"",
        dialogVisible:false,
        multi:false,
        open_getuser:false,
        open_detail:false,
        showBack:false,
      };
    },
    created() {
      if(this.$route.query.id && this.$route.query.id >0){
        this.showBack = true;
        this.formInline.search =  this.$route.query.id
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
                    /*返回上一页面*/
                    gotoBack(){
        this.$router.back(-1);
      },
      // 删除用户
      deleteUser(){
        this.formInline.user = {user_id:0};
        this.formInline.mobile = "";
      },
      /*打开获取用户*/
      openGetuser() {
        this.open_getuser = true;
      },
      evlClick(row){
        let self = this;
      this.$router.push({
        path: '/plus/notes/index',
        query: {
          notes_id: row.notes_id,
          type:'evl'
        }
      });
      },

      /*关闭获取用户*/
      closeGetuserFunc(e) {
        if (e.type != 'error') {
          this.formInline.user=e.params;
          this.formInline.mobile = e.params.mobile;
          this.getTableList();
        }
        this.open_getuser = false;

      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//动态标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeDetail(e){
      this.open_detail=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        NotesApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.notes_id = row.notes_id;
        this.open_edit = true
      },
      detailClick(row) {
        this.notes_id = row.notes_id;
        this.open_detail = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            NotesApi.del(
              {
                notes_id: row.notes_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style>
  .namex{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }</style>



// WEBPACK FOOTER //
// src/views/plus/notes/index/index.vue